
export const environment = {
  APP_ENV: 'live',
  API_SCHEME: 'https',
  API_DOMAIN: 'api.fedapay.com',
  API_VERSION: 'v1',
  SENTRY_DSN: 'https://b6a11553ed3d4615927f5c12e0b524af@sentry.io/303039',
  CYBERSOURCE_URL: 'https://secureacceptance.cybersource.com/silent/embedded/pay',
  CYBERSOURCE_UBA_SCRIPT_URL: 'https://api.cybersource.com/uc/v1/assets/1.0.0/UnifiedCheckout.js',
  STRIPE_PUBLIC_KEY: 'pk_live_yTo8sakoYPM4RyQKqVIeTaa100zJWPPfa4',
  EVISA_ACCOUNT_ID: '8055',
  GUFFE_ACCOUNT_ID: 'undefined',
  COVID_ACCOUNT_ID: '4967',
  GEO_API_URL: 'https://geo.fedapay.com'
};
